import { useCallback, useSyncExternalStore } from "react";

/**
 * CSS media query의 현재 일치 여부. 화면 폭이 바뀌면 다시 렌더한다.
 * 레이아웃은 가능하면 CSS(`md:` 등)로 처리하고, 컴포넌트 prop처럼 CSS로 바꿀 수 없는 값에만 쓴다.
 *
 * @example const isDesktop = useMediaQuery("(min-width: 768px)");
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener("change", onStoreChange);
      return () => mediaQueryList.removeEventListener("change", onStoreChange);
    },
    [query],
  );
  const getSnapshot = () => window.matchMedia(query).matches;

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
